/**
 * 状态集合
 * #0 初始化 [不可领奖]
 * #1 活动开始，未登录或已登录未参与，地理位置未初始化 => 点击按钮可获取位置信息 [未领奖]
 * #2 活动开始，未登录，距离===undefined =》置灰，授权定位后才可参与活动哦～ [不可领奖]
 * #3 活动开始，未登录，距离大于500 =》置灰，[不可领奖]
 * #4 活动开始，未登录，距离小于500 =》高亮，到店领奖，登录 [未领奖]
 * #5 活动开始，已登录，未参与，距离===undefined =》置灰，授权定位后才可参与活动哦～ [不可领奖]
 * #6 活动开始，已登录，未参与，距离大于500 =》置灰，到店领奖 [不可领奖]
 * #7 活动开始，已登录，未参与，距离小于500 =》高亮，领取盲盒，弹框 [未领奖]
 * #8 活动开始，已登录，已参与 =》高亮，查看奖励，配置的查看奖励页 [查看奖励]
 * #9 活动开始，已登录，不可参与 =》置灰 [不可领奖]
 * 
 * #0 初始化 => awardButtonStatus.REJECTED
 * #1 awardIssueStatus.PENDING && awardLocationStatus.UNINITIALIZED => awardButtonStatus.PENDING
 * #2 !isLogin && awardLocationStatus.REJECTED => awardButtonStatus.REJECTED
 * #3 !isLogin && awardLocationStatus.INVALID => awardButtonStatus.REJECTED
 * #4 !isLogin && awardLocationStatus.FULFILLED  => awardButtonStatus.PENDING
 * #5 isLogin && awardIssueStatus.PENDING && awardLocationStatus.REJECTED => awardButtonStatus.REJECTED
 * #6 isLogin && awardIssueStatus.PENDING && awardLocationStatus.INVALID => awardButtonStatus.REJECTED
 * #7 isLogin && awardIssueStatus.PENDING && awardLocationStatus.FULFILLED => awardButtonStatus.PENDING
 * #8 isLogin && awardIssueStatus.FULFILLED => awardButtonStatus.FULFILLED
 * #9 isLogin && awardIssueStatus.REJECTED => awardButtonStatus.REJECTED
 */

// 定位状态
export const awardLocationStatus = {
    UNINITIALIZED: 'uninitialized', // 未初始化
    PENDING: 'pending', // 获取中
    FULFILLED: 'fulfilled', // 获取成功且有效 或 不校验
    REJECTED: 'rejected', // 获取不到
    INVALID: 'invalid' // 无效
};

// 奖励发放状态
export const awardIssueStatus = {
    PENDING: 'pending', // 未领取
    FULFILLED: 'fulfilled', // 已领取
    REJECTED: 'rejected' // 不可领取
};

// 按钮状态
export const awardButtonStatus = {
    PENDING: 'notReceived', // 未领取 可点击
    FULFILLED: 'received', // 已领取 点击跳转查看
    REJECTED: 'notAvailable' // 不可领取 不可点击
};

// 按钮配置
export const buttonConfigMap = {
    [awardButtonStatus.PENDING]: {
        btnText: '到店领奖',
        btnImageName: 'notReceivedBtnImg',
        isClickable: true
    },
    [awardButtonStatus.FULFILLED]: {
        btnText: '查看奖励',
        btnImageName: 'receivedBtnImg',
        isClickable: true
    },
    [awardButtonStatus.REJECTED]: {
        btnText: '暂时无法领取',
        btnImageName: 'notAvailableBtnImg',
        isClickable: false
    }
};

// Click Type Enum
export const awardClickTypeEnum = {
  jumpToLogin: 'jumpToLogin',
  jumpToAward: 'jumpToAward',
  jumpToAppHome: 'jumpToAppHome',
  receiveAwards: 'receiveAwards',
  toHash: 'toHash',
  toastError: 'toastError'
}



// WEBPACK FOOTER //
// ./src/views/marketing/components/award/helper.js